// extracted by mini-css-extract-plugin
export var dividerContainer = "_9e-0";
export var line = "_9e-1";